import React from 'react';
import { Plus, Trash2, Percent } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';

// Admin: quantity price tiers ("à partir de N unités → −X %")
const PriceTierEditor = ({ tiers, unitPrice, onChange }) => {
  const price = parseFloat(unitPrice) || 0;
  const update = (idx, key, value) => onChange(tiers.map((t, i) => (i === idx ? { ...t, [key]: value } : t)));
  const remove = (idx) => onChange(tiers.filter((_, i) => i !== idx));
  const add = () => {
    const last = tiers[tiers.length - 1];
    onChange([...tiers, { min_qty: last ? (parseInt(last.min_qty, 10) || 2) * 2 : 3, discount_pct: last ? Math.min(90, (parseFloat(last.discount_pct) || 0) + 5) : 5 }]);
  };

  return (
    <div data-testid="tier-editor">
      <div className="flex items-center justify-between mb-2">
        <div>
          <h3 className="font-semibold text-gray-900 flex items-center gap-2"><Percent size={18} className="text-orange-500" /> Prix dégressifs (par quantité)</h3>
          <p className="text-xs text-gray-500">Le prix unitaire baisse automatiquement dans le panier à partir d'une quantité. La remise doit augmenter avec la quantité.</p>
        </div>
        <Button type="button" variant="outline" size="sm" onClick={add} data-testid="tier-add"><Plus size={14} className="mr-1" /> Ajouter un palier</Button>
      </div>
      {tiers.length > 0 && (
        <div className="space-y-2">
          {tiers.map((t, idx) => {
            const pct = parseFloat(t.discount_pct) || 0;
            const unit = price ? price * (1 - pct / 100) : 0;
            return (
              <div key={idx} className="grid grid-cols-12 gap-2 items-end bg-gray-50 border border-gray-200 rounded-lg p-3" data-testid={`tier-row-${idx}`}>
                <div className="col-span-5 sm:col-span-4">
                  <label className="block text-xs font-medium text-gray-600 mb-1">À partir de (unités)</label>
                  <Input data-testid={`tier-qty-${idx}`} type="number" min="2" step="1" value={t.min_qty} onChange={(e) => update(idx, 'min_qty', e.target.value)} />
                </div>
                <div className="col-span-5 sm:col-span-3">
                  <label className="block text-xs font-medium text-gray-600 mb-1">Remise (%)</label>
                  <Input data-testid={`tier-pct-${idx}`} type="number" min="1" max="90" step="0.5" value={t.discount_pct} onChange={(e) => update(idx, 'discount_pct', e.target.value)} />
                </div>
                <div className="col-span-12 sm:col-span-4 text-sm text-gray-700 h-10 flex items-center" data-testid={`tier-unit-${idx}`}>
                  {price ? <>Soit <strong className="mx-1">{unit.toFixed(2)} €</strong> / unité</> : <span className="text-gray-400">Renseignez le prix</span>}
                </div>
                <div className="col-span-2 sm:col-span-1 flex justify-end h-10 items-center">
                  <button type="button" data-testid={`tier-remove-${idx}`} onClick={() => remove(idx)} className="p-2 text-red-500 hover:bg-red-50 rounded"><Trash2 size={16} /></button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PriceTierEditor;
